var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-4"},_vm._l((_vm.orders),function(order,i){return _c('Order',{key:'order-' + i + '-' + order.reference,attrs:{"order":order}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }